import type * as React from 'react';

import { isRightToLeft, toLanguageCode } from 'js/lib/language';

import type Track from 'bundles/interactive-transcript/models/Track';

import _t from 'i18n!nls/interactive-transcript';

const isLanguageMismatch = (lang: string) => toLanguageCode(_t.getLocale()) !== lang;

const getDirection = (lang: string) => (isRightToLeft(lang) ? 'rtl' : undefined);

/**
 * Used to set the lang and dir html attributes on the interactive transcript when
 * the language is different from the user's current language setting. This is needed
 * for accessibility.
 */
export const getLanguageAttributes = (track: Track): React.HTMLAttributes<HTMLElement> => {
  const lang = toLanguageCode(track.languageCode);

  if (!isLanguageMismatch(lang)) {
    return {};
  }

  const dir = getDirection(lang);

  return { lang, dir };
};
